import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["results", "hidden"]
  static values = {
    title: { type: String, default: null },
    statuses: { type: Array},
    nameform: { type: String, default: "application_status" },
    selected: { type: String, default: null },
    attributes: { type: String, default: null },
  }

  connect() {
    this.stylesheet();
    this.hiddenResult();
    this.renderOptionsHtmlDefault();
  }

  renderOptionsHtmlDefault() {
    if (!this.hasHiddenTarget && this.hasResultsTarget && this.resultsTarget) {
      this.renderOptionsHtml();
    }
  }

  renderOptionsHtml() {
    this.resultsTarget.innerHTML = this.applicationStatusHtml();
  }

  hiddenResult() {
    if (this.hasHiddenTarget) {
      this.hiddenTarget.classList.add("d-none");
    }
  }

  displayResult() {
    if (this.hasHiddenTarget) {
      this.hiddenTarget.classList.remove("d-none");
    }
  }
  handleClick(event) {
    const isOpen = event.currentTarget.dataset.openapplicationstatus;
    if (isOpen == 1) {
      this.renderOptionsHtml();
      this.displayResult();
    } else {
      this.resultsTarget.innerHTML = "";
      this.hiddenResult();
    }
  }

  applicationStatusHtml() {
    let html = '';
    html+= '<div class="application-status-group d-flex flex-wrap">';
    for (let i = 0; i < this.statusesValue.length; i++) {
      html+= this.groupStatusHtml(this.statusesValue[i]);
    }
    html+= '</div">';
    return html;
  }

  groupStatusHtml(status) {
    let isChecked = this.hasSelectedValue ? this.selectedValue == status[1] : false;
    let attrs = this.hasAttributesValue ? this.attributesValue : null;
    let groupHtml = '<div class="form-check custom-form-check p-0">';
    groupHtml+= `<input class="form-check-input d-none" ${attrs} type="radio" value="${status[1]}" name="${this.nameformValue}" id="application_status_${status[1]}" ${isChecked ? 'checked' : ''}></input>`;
    groupHtml+= `<label for="application_status_${status[1]}" class="form-check-label btn btn-sm btn-outline-primary">${status[0]}</label>`;
    groupHtml+= '</div>';
    return groupHtml;
  }

  stylesheet() {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(`
      .application-status-group {
        gap: 1rem;

        .form-check.custom-form-check {
          .form-check-label {
            font-size: .85rem !important;
          }

          .form-check-input:checked~.form-check-label {
            background-color: #0b97e6;
            color: #fff;
          }
        }
      }
    `);
    document.adoptedStyleSheets = [...document.adoptedStyleSheets, sheet];
  }
}
